import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { initValidationsI18next } from '@youngcapital/validations';
import { Sentry } from './services/sentry';
import Blokkendoos from './services/blokkendoos';

const blokkendoos = new Blokkendoos();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(initValidationsI18next())
  .init({
    detection: {
      order: ['htmlTag'],
      caches: ['localStorage']
    },
    ns: ['university', 'candidate', 'cvbuilder', 'apply', 'common'],
    defaultNS: blokkendoos.getDefaultI18nNs() || 'candidate',
    fallbackNS: 'common',
    fallbackLng: 'en',
    lng: process.env.REACT_APP_LANGUAGE_OVERRIDE,
    interpolation: {
      formatSeparator: ','
    },
    returnObjects: true,
    debug: process.env.REACT_APP_I18N_DEBUG,
    react: {
      wait: true
    },
    backend: {
      loadPath: `${
        process.env.REACT_APP_DEV_URL || process.env.PUBLIC_URL
      }/locales/{{lng}}/{{ns}}.json`
    },

    // Use missingKeyHander to alert when keys are missing:
    // https://www.i18next.com/overview/configuration-options#missing-keys
    saveMissing: true,
    missingKeyHandler(lng, ns, key, fallbackValue, updateMissing, options) {
      if (options.defaultValue !== undefined) return;
      const message = `Missing translation for ${lng}.${ns}.${key}`;
      if (process.env.REACT_APP_ENVIRONMENT === 'development') {
        throw new TypeError(message);
      } else {
        Sentry.captureMessage(message);
      }
    }
  });

export default i18n;
